import { cartConfigEditableLoaderDefaultValue } from "../../monarch/Config | Editable Loader/default";
import { CartConfigEditableLoader, Loader, ProgressSteps } from "~/types/editable-loader";
import { isNonEmptyString } from "~/helpers/stringHelpers";

export const getProviderMetadata = ({
  unservRedirectProviderMetadata,
  provider,
}: {
  unservRedirectProviderMetadata: CartConfigEditableLoader["unservRedirectProvider"];
  provider: string;
}): { heading: string; subheading: string } | null => {
  for (const [providerKey, providerMetadata] of Object.entries(unservRedirectProviderMetadata)) {
    const normalizedProviderKey = providerKey === "atT" ? "at&t" : providerKey;
    // regex to support different variants of providers
    const regex = new RegExp(`\\b${normalizedProviderKey}\\b`, "i");
    if (regex.test(provider)) {
      return providerMetadata;
    }
  }
  return null;
};

const loaderPageFallback = (formattedPage: string): Loader => {
  const d = cartConfigEditableLoaderDefaultValue;
  switch (formattedPage) {
    case "_":
      return d._;
    case "_plan-package":
      return d["_plan-package"];
    case "_contact-credit":
      return d["_contact-credit"];
    case "_order":
      return d._order;
    case "_checkout":
      return d._checkout;
    default:
      return d._;
  }
};

/**
 * Monarch often returns page loader objects where empty strings overwrite defaults when spread.
 * Merge so blank / missing copy and theme fall back to bundled defaults for that route key.
 */
export const mergeEditableLoaderPageConfig = (
  formattedPage: string,
  monarchPage: Partial<Loader> | Loader | undefined | null
): Loader => {
  const fallback = loaderPageFallback(formattedPage);
  const m = monarchPage || {};
  let timerResolved = fallback.timer;
  if (m.timer != null && String(m.timer).trim() !== "") {
    const n = Number(m.timer);
    if (Number.isFinite(n)) {
      timerResolved = n;
    }
  }

  return {
    enabled: typeof m.enabled === "boolean" ? m.enabled : fallback.enabled,
    theme: isNonEmptyString(m.theme) ? m.theme : fallback.theme,
    icon: isNonEmptyString(m.icon) ? m.icon : fallback.icon,
    heading: isNonEmptyString(m.heading) ? m.heading : fallback.heading,
    subheading: isNonEmptyString(m.subheading) ? m.subheading : fallback.subheading,
    timer: timerResolved,
  };
};

export const mergeEditableLoaderProgressSteps = (monarch?: ProgressSteps | null): ProgressSteps => {
  const d = cartConfigEditableLoaderDefaultValue.progressSteps;
  if (!monarch) {
    return { ...d };
  }
  return {
    step1Title: isNonEmptyString(monarch.step1Title) ? monarch.step1Title : d.step1Title,
    step2Title: isNonEmptyString(monarch.step2Title) ? monarch.step2Title : d.step2Title,
    step3Title: isNonEmptyString(monarch.step3Title) ? monarch.step3Title : d.step3Title,
    step4Title: isNonEmptyString(monarch.step4Title) ? monarch.step4Title : d.step4Title,
  };
};
